import { readObjectRefId } from '../helper/object-ref';
import { subscribeToPointerHits } from './on-click-implementation';

/**
 * Hitbox clicks use the same ClickManager pointer-hit path as onClick, only the
 * target differs: a hitbox mesh, usually resolved by a Get Hitbox value node.
 * Targets are registered separately via onHitboxClick nodes in scene-builder.
 */
export function runOnHitboxClickImplementation(
  data: Record<string, unknown>,
  triggerOutPortFunctions: Map<string, () => void>
) {
  const targetId = readObjectRefId(data.target);
  if (!targetId) {
    throw new Error(
      'no hitbox resolved - the Hitbox input is empty or the hitbox is missing from the published scene'
    );
  }

  return subscribeToPointerHits(targetId, triggerOutPortFunctions);
}
